import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from "react";
import useCloseHandler from "../Category/hooks/useCloseHandler";
import { useFunnel } from "../Funnel";
import AnchorDrawer from "../modal/AnchorDrawer";
import { SideSheetAdListStep, SideSheetDefaultStep, SideSheetMenuListStep } from "./SideSheetSteps";
import { useSideCategoryMenuStore } from "./store/useCategoryMenuStore";
export const SideSheetSteps = {
    default: "default",
    menuList: "menuList",
    adList: "adList"
};
export const GNBSideSheet = (param)=>{
    let { onLogout  } = param;
    useCloseHandler();
    const { isOpenMobileSideMenu , openMobileSideMenu , closeSideMenu , setState  } = useSideCategoryMenuStore();
    const [Funnel, setStep] = useFunnel([
        SideSheetSteps.default,
        SideSheetSteps.menuList,
        SideSheetSteps.adList
    ], SideSheetSteps.default);
    const [currentMenu, setCurrentMenu] = useState(null);
    const goToNextStep = (step)=>{
        setStep(step);
    };
    const goToPrevStep = useCallback(()=>{
        setStep(SideSheetSteps.default);
        setState("twoDepthId", "");
        setState("threeDepthId", "");
    }, [
        setState
    ]);
    useEffect(()=>{
        if (!isOpenMobileSideMenu) setStep(SideSheetSteps.default);
    }, [
        isOpenMobileSideMenu
    ]);
    return /*#__PURE__*/ _jsx(AnchorDrawer, {
        anchor: "right",
        open: isOpenMobileSideMenu,
        onClose: closeSideMenu,
        children: isOpenMobileSideMenu && /*#__PURE__*/ _jsxs(Funnel, {
            children: [
                /*#__PURE__*/ _jsx(Funnel.Step, {
                    name: SideSheetSteps.default,
                    children: /*#__PURE__*/ _jsx(SideSheetDefaultStep, {
                        goToNextStep: goToNextStep,
                        setCurrentMenu: setCurrentMenu,
                        onClose: closeSideMenu
                    })
                }),
                /*#__PURE__*/ _jsx(Funnel.Step, {
                    name: SideSheetSteps.menuList,
                    children: /*#__PURE__*/ _jsx(SideSheetMenuListStep, {
                        goToPrevStep: goToPrevStep,
                        onClose: ()=>{
                            setStep(SideSheetSteps.default);
                            closeSideMenu();
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Funnel.Step, {
                    name: SideSheetSteps.adList,
                    children: /*#__PURE__*/ _jsx(SideSheetAdListStep, {
                        goToPrevStep: goToPrevStep,
                        onClose: closeSideMenu
                    })
                })
            ]
        })
    });
};
